import { SHARED_STORES } from './shared/stores/index';

export const STORES = [...SHARED_STORES];
